"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var SPINNER_SIZE = '300px';
var SPINNER_INNER_CIRCLE = '40px';
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    spinnerBox: {
      display: 'flex',
      justifyContent: 'center',
      height: '100%',
      alignItems: 'center'
    },
    spinnerContainer: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column'
    },
    spinner: {
      margin: 'auto',
      display: 'block',
      height: SPINNER_SIZE,
      width: SPINNER_SIZE,
      position: 'relative',
      animation: "$spin .875s linear 0s infinite normal",
      '&::before, &::after': {
        content: "\"\"",
        display: 'block'
      },
      '&::before': {
        height: SPINNER_SIZE,
        width: '50%',
        top: 0,
        right: 0,
        zIndex: 1
      },
      '&::after': {
        height: SPINNER_INNER_CIRCLE,
        width: SPINNER_INNER_CIRCLE,
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 1
      }
    },
    '@keyframes spin': {
      'to': {
        transform: 'rotate(-360deg)'
      }
    }
  };
});

/**
 * Spins the image given.
 * @param {Image} loadingIcon the loading icon for the specific theme must be an image.
 * @returns 
 */
var VNSpinner = function VNSpinner(props) {
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: classes.spinnerBox
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: classes.spinnerContainer
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: props.loadingIcon,
    className: classes.spinner,
    alt: "loading"
  })));
};
var _default = VNSpinner;
exports.default = _default;